module.exports = __webpack_public_path__ + "static/media/galerija_2019 (31).01da68d6.jpg";